module.exports = __webpack_public_path__ + "media/images/1200/healthy-c36bb2d61de49e7cb3e4aa1f9a970764.webp";